import { Event, EventJson, ExtraFormData, SubEvent, SubEventJson } from 'inscreva-sse-models';
import moment from 'moment';

import { EventDateHelper } from '../services/EventDateHelper';
import { Subscription } from './subscription';

export class EventUI {
  expanded = false;

  favorited = false;

  subscription?: Subscription;

  subEventsUI: Array<EventUI>;

  public event: Event | SubEvent;

  notification = 1440;

  timezone?: string;

  toggle(): EventUI {
    this.expanded = !this.expanded;

    return this;
  }

  favorite(): EventUI {
    this.event.extraFormData = this.event.extraFormData || ({} as ExtraFormData);
    this.event.extraFormData.favorited = !this.event.extraFormData.favorited;
    this.favorited = !this.favorited;

    return this;
  }

  select(): EventUI {
    if (this.is_sub_event) {
      (this.event as SubEvent).selected = true;
    }

    return this;
  }

  get is_full(): boolean {
    return (this.event as any).subscriptionCount >= (this.event as any).info.maxAttendees;
  }

  getFormattedDate(date: string, sameDay?: boolean): string {
    return (date && moment(date).format(`${!sameDay ? 'DD/MM/YYYY ' : ''}HH:mm`)) || '';
  }

  get formatted_date(): string {
    return EventDateHelper.getDate(this.event.info.date);
  }

  get sub_events_ui(): Array<EventUI> {
    return ((this.event as Event).subEvents || []).map((subEvent: SubEvent) => new EventUI(subEvent));
  }

  isSubEvent(event: Event | SubEvent): event is SubEvent {
    return !!(event as SubEvent).parent;
  }

  get is_sub_event(): boolean {
    return this.isSubEvent(this.event);
  }

  get is_selectable(): boolean {
    if (!this.is_sub_event) {
      return true;
    }
  }

  get alias(): string {
    return (this.event as Event).alias || '';
  }

  get image(): string {
    return this.event.info.image;
  }

  get is_form_fist(): boolean {
    return (this.event as Event).formFirst;
  }

  get first_page(): string {
    return `/${this.alias}/${(this.is_form_fist && 'sign-in') || ''}`;
  }

  get description(): string {
    const { description } = this.event.info;

    if (this.expanded) {
      return description;
    }

    return description.split(' ').slice(0, 15).join(' ');
  }

  get has_card_field_value(): boolean {
    return (this.event.cardFields || []).some(({ value }) => !!value);
  }

  get is_online(): boolean {
    return (this.event as Event).extraInfo?.isOnline;
  }

  constructor(event: Event | SubEvent) {
    this.event = this.isSubEvent(event) ? SubEventJson.fromJson(event) : EventJson.fromJson(event as Event);

    if (!this.is_sub_event) {
      this.subEventsUI = ((this.event as Event).subEvents || []).map((subEvent: SubEvent) => new EventUI(subEvent));
    }
  }
}
